import React from 'react'
import * as LucideIcons from 'lucide-react'

const variants = {
  primary: 'bg-primary-700 text-white hover:bg-primary-800 active:bg-primary-900 focus:ring-primary-500',
  secondary: 'bg-secondary-600 text-white hover:bg-secondary-700 active:bg-secondary-800 focus:ring-secondary-500',
  accent: 'bg-accent-500 text-white hover:bg-accent-600 active:bg-accent-700 focus:ring-accent-400',
  outline: 'border-2 border-primary-700 text-primary-700 hover:bg-primary-50 active:bg-primary-100 focus:ring-primary-500',
  ghost: 'text-primary-700 hover:bg-primary-50 active:bg-primary-100 focus:ring-primary-500',
  danger: 'bg-red-600 text-white hover:bg-red-700 active:bg-red-800 focus:ring-red-500'
}

const sizes = {
  sm: 'px-3 py-2 text-sm',
  md: 'px-4 py-3 text-base',
  lg: 'px-6 py-4 text-lg',
  icon: 'p-3'
}

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  iconPosition = 'left',
  loading = false,
  disabled = false,
  fullWidth = false,
  className = '',
  type = 'button',
  onClick,
  ...props
}) {
  const IconComponent = icon ? LucideIcons[icon] : null

  // Prevent form submission when clicking button
  const handleClick = (e) => {
    if (type === 'button') {
      e.preventDefault()
    }
    if (onClick) {
      onClick(e)
    }
  }

  const baseClasses = `
    inline-flex items-center justify-center
    font-medium rounded-lg
    transition-colors duration-200
    focus:outline-none focus:ring-2 focus:ring-offset-2
    disabled:opacity-50 disabled:cursor-not-allowed
  `

  const classes = `
    ${baseClasses}
    ${variants[variant]}
    ${sizes[size]}
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `.trim().replace(/\s+/g, ' ')

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={handleClick}
      {...props}
    >
      {loading ? (
        <>
          <span className="spinner mr-2" />
          Loading...
        </>
      ) : (
        <>
          {IconComponent && iconPosition === 'left' && (
            <IconComponent className={`w-5 h-5 ${children ? 'mr-2' : ''}`} />
          )}
          {children}
          {IconComponent && iconPosition === 'right' && (
            <IconComponent className={`w-5 h-5 ${children ? 'ml-2' : ''}`} />
          )}
        </>
      )}
    </button>
  )
}
